import "./BusinessHub.module.css";
import Header from "@/reusable_sections/Header";
import ExpertSolutionsForEveryPipe from "./sections/ExpertSolutionsForEveryPipe";
import SubscriptionPlans from "./sections/SubscriptionPlans";
import FloralMembersPortal from "./sections/FloralMembersPortal";
import Footer from "@/reusable_sections/Footer";
export default function BusinessHubPage() {
  return <div>
      <Header />
      <ExpertSolutionsForEveryPipe />
      <SubscriptionPlans />
      <FloralMembersPortal />
      <Footer />
    </div>;
}